import { SET_STANDARD_FEATURES } from '../actions/types';

export default function standardFeatures(state = [], action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_STANDARD_FEATURES:
				return action.payload;

			// no default
		}
	}

	return state;
}
